<template>
  <div v-if="attendance">
    <navigation-drawer color="primary" dark app permanent>
      <v-card tile elevation="0">
        <v-row>
          <v-col class="primary text-center primary-light1--text">
            <v-row dense justify="space-around" align="center">
              <v-col cols="auto">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      class="ml-7"
                      v-on="on"
                      :attrs="attrs"
                      @click="redirectBackToQueue"
                    >
                      <div class="primary-light1--text">
                        <v-icon>mdi-chevron-left</v-icon>
                        <span>Filas</span>
                      </div>
                    </v-btn>
                  </template>
                  <span>Fila de Atendimento</span>
                </v-tooltip>
              </v-col>
              <v-col cols="auto">
                <ActionNextWorkflow
                  :attendance="attendance"
                  :nextWorkflowStatus="attendance.permittedWorkflowStatuses"
                  :startAttendance="startAttendance"
                  v-slot:default="{ clickEvent, on, attrs }"
                >
                  <v-btn
                    small
                    icon
                    :attrs="attrs"
                    v-on="on"
                    @click="clickEvent"
                  >
                    <v-icon class="primary text-center primary-light1--text">
                      eva-more-vertical-outline
                    </v-icon>
                  </v-btn>
                </ActionNextWorkflow>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <PatientAvatar :attendance="attendance" />
              </v-col>
            </v-row>

            <v-row dense justify="center">
              <v-col cols="auto">
                <PatientRisk
                  :attendance="attendance"
                  :attendanceEsigned="attendanceEsigned"
                  defaultColor="white"
                />
              </v-col>
            </v-row>

            <v-row dense justify="center">
              <v-col cols="auto">
                <WorkflowableStatus :workflowable="attendance" color="white" />
              </v-col>
            </v-row>

            <v-row dense v-if="showScheduledFor">
              <v-col>
                Consulta do dia
                {{ attendance.createdAt | moment("DD/MM/Y") }}
              </v-col>
            </v-row>

            <v-row dense>
              <v-col> #{{ attendance.patient.warelineId }} </v-col>
            </v-row>

            <v-row dense>
              <v-col class="font-weight-bold">
                {{ attendance.patient.name }}
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                {{ attendance.patient.birthDate | moment("DD/MM/Y") }}
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                {{ formatedAge }}
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                {{ attendance.healthInsuranceProductName }}
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                {{ attendance.employee.name }}
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <AttendanceNotes
                  :notes="attendance.notes"
                  :attendanceId="attendance.id"
                  :darkColor="darkColor"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </navigation-drawer>

    <v-app-bar color="white" flat app>
      <v-tabs
        centered
        background-color="transparent"
        color="light-blue"
        show-arrows
      >
        <v-tab :to="`/prontuario/${attendance.id}`">Prontuário</v-tab>

        <v-tab :to="`/prontuario/${attendance.id}/terapeutica`"
          >Terapêutica</v-tab
        >

        <v-tab :to="`/prontuario/${attendance.id}/receituario`"
          >Receituário</v-tab
        >

        <v-tab :to="`/prontuario/${attendance.id}/receitas-oculos`"
          >Receitas de óculos</v-tab
        >

        <v-tab :to="`/prontuario/${attendance.id}/atestados`">Atestados</v-tab>

        <v-tab :to="`/prontuario/${attendance.id}/solicitacao-exames`">
          Solicitação médica
        </v-tab>

        <v-tab :to="`/prontuario/${attendance.id}/lentes-contato`">
          Lentes de contato
        </v-tab>

        <v-tab :to="`/prontuario/${attendance.id}/cirurgia`"> Cirurgias </v-tab>

        <v-tab :to="`/prontuario/${attendance.id}/movimentacao-paciente`">
          Movimentação Paciente
        </v-tab>
      </v-tabs>
    </v-app-bar>

    <v-container fluid>
      <router-view
        :attendance="attendance"
        :attendanceEsigned="attendanceEsigned"
      />
    </v-container>
  </div>
</template>

<script>
// disabled E-sign
// import Vue from "vue";
// import Lacuna from "@/plugins/lacuna";
//  created() {
//   Vue.use(Lacuna)'
// }

import PatientAvatar from "@/components/queues/attendance/patient_avatar/index.vue";
import PatientRisk from "@/components/queues/attendance/patient_risk/index.vue";
import WorkflowableStatus from "@/components/workflowable/status.vue";
import AttendanceNotes from "@/components/attendance/notes.vue";
import ActionNextWorkflow from "@/components/queues/attendance/actions/next_workflow.vue";
import GET_ATTENDANCE from "@/graphql/attendance.js";
import CHANGE_WORKFLOW_STATUS from "@/graphql/change_workflow_status.gql";
import { buildSubscription } from "@/components/graphql/subscriptions.js";
import NOTES_UPDATED from "@/graphql/subscriptions/attendance/notes_updated.gql";

export default {
  name: "AttendanceLayout",
  components: {
    PatientAvatar,
    PatientRisk,
    WorkflowableStatus,
    AttendanceNotes,
    ActionNextWorkflow,
  },
  data() {
    return {
      attendance: null,
      redirectTo: "/",
      darkColor: true,
    };
  },
  created() {
  },
  mounted() {
    this.refreshList();
    if (this.$route.query.redirectTo) {
      this.redirectTo = this.$route.query.redirectTo;
    }
  },
  apollo: {
    attendance: {
      query: GET_ATTENDANCE,
      deep: true,
      variables() {
        return {
          attendanceId: this.attendance_id,
        };
      },
      pollInterval: 30000,  // old = 10s
    },
    $subscribe: {
      attendanceNotesUpdated() {
        return buildSubscription({
          query: NOTES_UPDATED,
          variables: {
            attendanceId: this.attendance_id,
          },
          onSuccess: ({ attendanceNotesUpdated: { notes, attendanceId } }) => {
            if (attendanceId !== this.attendance_id) return;
            this.attendance.notes = notes;
          },
          onSubscriptionLoadStatusUpdate: (value) => {
            this.subscriptionLoaded = value;
          },
          errorNotificationMessage:
            "Ocorreu um erro ao tentar atualizar as notas de paciente.\n" +
            "Você não está recebendo mais atualizações, recarregue a página para atualizar.",
        });
      },
    },
  },
  computed: {
    attendance_id() {
      return this.$route.params.attendance_id;
    },
    formatedAge() {
      const diffDates =
        new Date() - new Date(this.attendance.patient.birthDate);
      const years = this.$moment.duration(diffDates).years();
      const months = this.$moment.duration(diffDates).months();

      const age = [];

      if (years === 1) {
        age.push(`${years} ano`);
      } else if (years > 1) {
        age.push(`${years} anos`);
      }

      if (months === 1) {
        age.push(`${months} mês`);
      } else if (months > 1) {
        age.push(`${months} meses`);
      }

      return age.join(" e ");
    },
    attendanceEsigned() {
      return this.attendance.lastEsign.status === "signed";
    },
    showScheduledFor() {
      const diffDates = new Date() - new Date(this.attendance.scheduledFor);
      const days = this.$moment.duration(diffDates).days();

      return days > 0;
    },
    currentWorkflowStatus() {
      if (this.lastWorkflowLog) {
        return this.attendance.lastWorkflowLog.toStatus;
      }

      return null;
    },
    isCurrentUserDoctor() {
      return (
        this.$store.state.authentication?.user?.employee?.employee_type ==
        "doctor"
      );
    },
  },
  methods: {
    redirectBackToQueue() {
      if (this.isCurrentUserDoctor) {
        this.$router.push("/filas/medico");
        return;
      }

      this.$router.push(this.redirectTo);
    },
    refreshList() {
      this.$apollo.queries.attendance.refetch();
    },
    startAttendance(workflow_status, attendancePlaceId) {
      //seguir o fluxo de execução: 0= Não, 1= Sim
      let vnExecute = 1;

      if (attendancePlaceId == null) {
        if (confirm("Você realmente deseja finalizar o atendimento?"))
          vnExecute = 1;
        else vnExecute = 0;
      }

      //se for para executar atualização da da situação do atendimento faça
      if (vnExecute === 1) {
        this.apolloMutate({
          mutation: CHANGE_WORKFLOW_STATUS,
          variables: {
            attendanceId: this.attendance.id,
            workflowStatusId: workflow_status.id,
            attendancePlaceId: attendancePlaceId,
          },
        })
          .then(() => {
            this.$store.dispatch("createNotification", {
              message: `Paciente ${workflow_status.name}`,
              type: "success",
            });
            this.$apollo.queries.attendance.refetch();
          })
          .catch((error) => {
            const errorMessage = error.message.replace("GraphQL error: ", "");

            this.$store.dispatch("createNotification", {
              message: errorMessage,
              type: "error",
            });
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
